



























































































































































































import { ContractsPanelVue } from "fs-pb-vue2/vueModels/contracts-panel/ContractsPanelVue";
import { Component } from "vue-property-decorator";
import ContractBlock from "@/components/contracts-panel/ContractBlock.vue";
import DepositBlock from "@/components/contracts-panel/DepositBlock.vue";

@Component({
  components: { ContractBlock, DepositBlock }
})
export default class ContractsPanel extends ContractsPanelVue {

  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }

}
